/* corenaturals – Ads-Landingpage
   1) Sticky-Leiste einblenden, sobald der Haupt-Warenkorb-Button aus dem Bild ist
   2) Video-Play-Button in der Routine-Section */
(function () {
  if (window.cnLpInit) return;
  window.cnLpInit = true;

  function initSticky() {
    var bar = document.querySelector('[data-cn-sticky]');
    if (!bar || bar.dataset.cnBound) return;
    bar.dataset.cnBound = '1';

    var footer = document.querySelector('.shopify-section-group-footer-group, .shopify-section--footer, footer');
    var ticking = false;

    function update() {
      ticking = false;
      var main = document.querySelector('[data-cn-atc-main]');
      /* sichtbar, sobald der Haupt-Button nach oben aus dem Bild gescrollt ist (ohne Haupt-Button: nach 600 px) */
      var passedMain = main ? main.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = passedMain && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
    }

    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initVideos(root) {
    (root || document).querySelectorAll('[data-cn-video]').forEach(function (wrap) {
      if (wrap.dataset.cnBound) return;
      wrap.dataset.cnBound = '1';
      var btn = wrap.querySelector('[data-cn-play]');
      var video = wrap.querySelector('video');
      var tpl = wrap.querySelector('template');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (video) {
          video.controls = true;
          video.muted = false;
          video.play();
        } else if (tpl) {
          wrap.appendChild(tpl.content.cloneNode(true));
        }
        btn.hidden = true;
      });
    });
  }

  function init() { initSticky(); initVideos(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-Editor: nach dem Neuladen einer Section erneut initialisieren */
  document.addEventListener('shopify:section:load', function (e) {
    var bar = document.querySelector('[data-cn-sticky]');
    if (bar) delete bar.dataset.cnBound;
    initSticky();
    initVideos(e.target);
  });
})();
